import { useState, useEffect } from 'react';
import API from '../api';

/** Conta notifiche "high" e si aggiorna ogni 60s. Ritorna 0 se utente non autenticato. */
export function useNotificationCount(user) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!user) return undefined;
    const fetchNotif = () => API.get('/api/notifiche')
      .then(r => setCount(r.data?.high || 0))
      .catch(() => {});
    fetchNotif();
    const id = setInterval(fetchNotif, 60000);
    return () => clearInterval(id);
  }, [user]);
  return count;
}
